/**
 * Created by rxsl-106 on 2017/8/22.
 */
import api from './index';
/**
 * Created by rxsl-106 on 2017/8/22.
 */
let exports = {};

//==========================商户付款时机==========================
exports.getMerchantPayTimingList = function (data, callback) {// 获取商户付款时机列表
    api.post('/merchtFinac/merchant/pay/timing/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantPayTimingListAvailable = function (data, callback) {// 获取商户未禁用的付款时机列表
    api.post('/merchtFinac/merchant/pay/timing/list/get/available')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantPayTiming = function (params, callback) {// 根据id查询
    api.get('/merchtFinac/merchant/pay/timing/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantPayTiming = function (data, callback) {// 保存商户付款时机
    api.post('/merchtFinac/merchant/pay/timing/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.updateMerchantPayTimingDefaulted = function (params, callback) {// 设置商户默认的付款时机
    api.post('/merchtFinac/merchant/pay/timing/defaulted/update/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantPayTimingDisabled = function (data, callback) {// 是否禁用商户支持的付款时机
    api.post('/merchtFinac/merchant/pay/timing/disabled/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.moveMerchantPayTimingSeq = function (data, callback) {// 上下移动付款时机
    api.post('/merchtFinac/merchant/pay/timing/seq/move/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantPayTiming = function (params, callback) {// 刪除商户付款时机
    api.post('/merchtFinac/merchant/pay/timing/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

//==========================商户付款方式==========================

exports.getMerchantPayWayList = function (data, callback) {// 获取商户付款方式列表
    api.post('/merchtFinac/merchant/pay/way/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getEnabledMerchantPayWayList = function (data, callback) {// 获取商户未禁用的付款方式列表
    api.post('/merchtFinac/merchant/enabled/pay/way/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantPayWay = function (params, callback) {// 根据id查询商户付款方式
    api.get('/merchtFinac/merchant/pay/way/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantPayWay = function (data, callback) {// 保存商户付款方式
    api.post('/merchtFinac/merchant/pay/way/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.updateMerchantPayWayDefaulted = function (params, callback) {// 设置默认商户付款方式
    api.post('/merchtFinac/merchant/pay/way/defaulted/update/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantPayWayDisabled = function (data, callback) {// 是否禁用商户付款方式
    api.post('/merchtFinac/merchant/pay/way/disabled/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.moveMerchantPayWaySeq = function (data, callback) {// 上下移动付款方式
    api.post('/merchtFinac/merchant/pay/way/seq/move/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantPayWay = function (params, callback) {// 刪除商户付款方式
    api.post('/merchtFinac/merchant/pay/way/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

//==========================商户发票类型==========================
exports.getMerchantInvoiceTypeList = function (data, callback) {// 获取商户发票类型列表
    api.post('/merchtFinac/merchant/invoice/type/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceTypeListAvailable = function (data, callback) {// 获取未禁用的商户发票类型列表
    api.post('/merchtFinac/merchant/invoice/type/list/get/available')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceType = function (params, callback) {// 根据id查询
    api.get('/merchtFinac/merchant/invoice/type/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantInvoiceType = function (data, callback) {// 保存商户发票类型
    api.post('/merchtFinac/merchant/invoice/type/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceTypeDefaulted = function (params, callback) {// 设置商户默认发票类型
    api.post('/merchtFinac/merchant/invoice/type/defaulted/update/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceTypeDisabled = function (data, callback) {// 是否禁用
    api.post('/merchtFinac/merchant/invoice/type/disabled/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.moveMerchantInvoiceTypeSeq = function (data, callback) {// 上下移动发票类型
    api.post('/merchtFinac/merchant/invoice/type/seq/move/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantInvoiceType = function (params, callback) {// 刪除商户发票类型
    api.post('/merchtFinac/merchant/invoice/type/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
//=============================商户（支持的）发票内容标签==============================

exports.getMerchantInvoiceCtntTagList = function (data, callback) {// 获取商户发票内容标签列表
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantInvoiceCtntTag = function (data, callback) {// 保存商户发票内容标签
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceCtntTag = function (params, callback) {// 根据id查询商户发票内容标签
    api.get('/merchtFinac/merchant/invoice/ctnt/tag/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantInvoiceCtntTag = function (params, callback) {// 根据id删除商户发票内容标签
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceCtntTag = function (data, callback) {// 根据id修改商户发票内容标签
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceCtntTagDefaulted = function (data, callback) {// 设置商户发票内容标签默认
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/defaulted/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.moveMerchantInvoiceCtntTagSeq = function (data, callback) {// 上下移条目
    api.post('/merchtFinac/merchant/invoice/ctnt/tag/seq/move/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

//=============================发票主体信息==============================
exports.getMerchantInvoiceSubjectByUkAvailable = function (data, callback) {// 根据唯一键获取为禁用的发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/get/by/uk/available')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceSubjectList = function (data, callback) {// 获取商户发票主体信息列表
    api.post('/merchtFinac/merchant/invoice/subject/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceSubject = function (data, callback) {// 根据id修改发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.deleteMerchantInvoiceSubject = function (params, callback) {// 根据id删除发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/delete/do')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getMerchantInvoiceSubject = function (params, callback) {// 根据id查询发票主体信息
    api.get('/merchtFinac/merchant/invoice/subject/get')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};
exports.saveMerchantInvoiceSubject = function (data, callback) {// 保存发票主体信息
    api.post('/merchtFinac/merchant/invoice/subject/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateMerchantInvoiceSubjectDisabled = function (data, callback) {// 发票主题信息的启用/禁用
    api.post('/merchtFinac/merchant/invoice/subject/disabled/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.updateMerchantInvoiceSubjectForDefaulted = function (data, callback) {// 发票主题信息的默认
    api.post('/merchtFinac/merchant/invoice/subject/defaulted/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go()
};

// =============================== 银行账号 =========================================


exports.getMerchantBankAcctByUsage = function (data, callback) {// 查询默认收款账号
    api.post('/merchtFinac/merchant/bank/acct/defaulted/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtFinac.js
// module id = 48
// module chunks = 1